import { useQuery } from '@tanstack/react-query';

import getTotalRequestReschedule from 'Api/reschedule/getTotalRequestReschedule';

import getTotalRequestReschedulePayload from './model/request/getTotalRequestReschedulePayload';
import getTotalRequestRescheduleResponse from './model/response/getTotalRequestRescheduleResponse';

const useGetTotalRequestReschedule = () => {
  return useQuery({
    queryKey: ['total-request-reschedule'],
    queryFn: async () => {
      const queryParams = getTotalRequestReschedulePayload();

      const response = await getTotalRequestReschedule(queryParams);

      const result = getTotalRequestRescheduleResponse(response);

      return result;
    },
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
  });
};

export default useGetTotalRequestReschedule;
